/**
 * Pure matchmaking entry point — accepts V1 or legacy frozen input (migrated at entry).
 */

import { migrateMatchmakingInput } from './matchmakingInputV1.js';
import { applyPendingFinishGameToV1State } from './sessionMatchModel.js';
import { runAllTargetFills } from './internal/slotFill.js';

export function runMatchmakingFromFrozenInput(frozenInput, { prng = null, debug = false } = {}) {
  const v1 = applyPendingFinishGameToV1State(migrateMatchmakingInput(frozenInput));
  return runAllTargetFills(v1, { prng, debug });
}
